import { useMemo } from "react";
import { FileImageType, FileThumbnail } from "domains/file-manager/interfaces";

interface GetFileImagePlaceholdersArgs {
  length: number;
  dimensions?: {
    width: number;
    height: number;
  };
  hideDimensions?: boolean;
}

export const useGetFileImagePlaceholders = ({
  length,
  dimensions,
  hideDimensions,
}: GetFileImagePlaceholdersArgs): FileImageType[] => {
  return useMemo(
    () =>
      Array.from({ length }, (_, index) => ({
        type: "image",
        id: `placeholder-${index}`,
        name: `placeholder-${index}`,
        thumbnail: "" as FileThumbnail,
        width: dimensions?.width ?? 512,
        height: dimensions?.height ?? 512,
        isLoading: false,
        status: "placeholder",
        meta: {
          createdAt: new Date("2000-01-01 00:00:00").toString(),
          metadata: {
            kind: "image",
            type: "inference-img2img",
            width: dimensions?.width,
            height: dimensions?.height,
          },
          kind: "image",
          source: "inference-txt",
          properties: {
            size: 0,
          },
          url: "",
          tags: [
            dimensions?.width !== undefined && !hideDimensions
              ? ""
              : "no-dimensions",
          ],
          updatedAt: new Date("2000-01-01 00:00:00").toString(),
          collectionIds: [],
          privacy: "private",
          id: `placeholder-${index}`,
          mimeType: "",
          authorId: "",
          ownerId: "",
          status: "success",
          editCapabilities: [],
        },
      })),
    [length, dimensions?.height, dimensions?.width, hideDimensions]
  );
};
